import { render, staticRenderFns } from "./Answersheet.vue?vue&type=template&id=57b6c5de&scoped=true&"
import script from "./Answersheet.vue?vue&type=script&lang=js&"
export * from "./Answersheet.vue?vue&type=script&lang=js&"
import style0 from "./Answersheet.vue?vue&type=style&index=0&id=57b6c5de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6c5de",
  null
  
)

export default component.exports